module.exports = __webpack_public_path__ + "static/media/potage.d13481c2.svg";